import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    designationList: [],
    designationRecord: [],
    designationsDropdownList: [],
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false,
}

const DesignationReducer = (state = initialState, action) => {
    switch (action.type) {
       
    case actionTypes.DESIGNATION_REQUEST:
        return {
          ...state,
          Loading: true,
          validation_error: "",
          redirect_to_list: false,
        }
    case actionTypes.DESIGNATION_SUCCESS:
        return {
          ...state, 
          Loading: false,
          redirect_to_list: false,
          validation_error: "",
          designationList: action.designationList,
          showUpdateForm: false,
          showViewPage: false,
          designationRecord: [],
        } 
    case actionTypes.DESIGNATION_SERVER_SUCCESS:
        return {
          ...state, 
          Loading: false,
          redirect_to_list: false,
          validation_error: "",
          showUpdateForm: false,
          showViewPage: false,
          designationRecord: [],
        }          
    case actionTypes.DESIGNATION_GET_SUCCESS:
        return {
            ...state, 
            Loading: false,
            redirect_to_list: false,
            designationRecord: action.record,
            showUpdateForm: (action.actionType === 'update')? true:false,
            showViewPage: (action.actionType === 'view')? true:false,
        }    
    case actionTypes.DESIGNATIONS_DROPDOWN_LIST_SUCCESS:
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            designationsDropdownList: action.designationsDropdownList,
        }
    case actionTypes.DESIGNATION_VALIDATION_ERROR:
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            validation_error: action.validation_error,
        } 
    case actionTypes.HIDE_DESIGNATION_FEILD_VALIDATION_ERROR:
        if(state.validation_error && state.validation_error[action.feild_key])
            delete state.validation_error[action.feild_key]
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            validation_error: action.validation_error,
            
        } 
    case actionTypes.REDIRECT_TO_DESIGNATION_LIST:
        return {
            ...state,
            redirect_to_list: true,
            showUpdateForm: false,
            showViewPage: false,
            validation_error: '',
            designationRecord: [],
        }   
    default:
        return state;
    }
}

export default DesignationReducer;
